import styled from 'styled-components';
import React, {FC} from 'react';

import {fontSizesMixins, palette, transition, mediaBreakpointDown} from '../../../../lib/styleVariables';
import {Icon} from '../../../molecules/icon';

interface NavigationCallToActionSmallProps {
  color?: 'gray' | 'black' | 'blue';
  title: React.ReactNode;
  description: string;
  href: string;
}

const StyledIcon = styled(Icon)`
  transition: ${transition.fast} ease-in-out;

  ${mediaBreakpointDown('mobile')} {
    width: 24px;
    height: 24px;
  }
`;

const StyledContainer = styled.a`
  background-color: ${palette.black.base};
  border-radius: 32px 4px 32px 32px;
  display: flex;
  padding: 36px 40px;
  text-decoration: none;
  transition: box-shadow ${transition.fast} ease-in-out;

  ${mediaBreakpointDown('mobile')} {
    padding: 8px;
  }

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.32);
    ${StyledIcon} {
      transform: translate(4px, -4px);
    }
  }
`;

const StyledLeftContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${mediaBreakpointDown('mobile')} {
    padding: 12px 0 16px 16px;
  }
`;

const StyledRightContainer = styled.div`
  margin-left: 5px;
`;

const StyledTitle = styled.span`
  ${fontSizesMixins.h3()};
  color: ${palette.white.base};
  ${mediaBreakpointDown('mobile')} {
    font-weight: 500;
  }
`;

const StyledDescription = styled.span`
  ${fontSizesMixins.text2Spread()};
  color: ${palette.white.base};

  ${mediaBreakpointDown('mobile')} {
    ${fontSizesMixins.text3()};
    margin-top: 5px;
  }
`;

export const NavigationCallToActionSmall: FC<NavigationCallToActionSmallProps> = props => (
  <StyledContainer href={props.href}>
    <StyledLeftContainer>
      <StyledTitle>{props.title}</StyledTitle>
      <StyledDescription>{props.description}</StyledDescription>
    </StyledLeftContainer>
    <StyledRightContainer>
      <StyledIcon name="externalLink" size={32} />
    </StyledRightContainer>
  </StyledContainer>
);
